import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const TopView = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
};

export default TopView;
